import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=db819fde&scoped=true"
import script from "./CardActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardActions.vue?vue&type=style&index=0&id=db819fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db819fde",
  null
  
)

export default component.exports